// EPosition
export var ENotificationPosition;
(function (ENotificationPosition) {
    ENotificationPosition[ENotificationPosition["TopLeft"] = 0] = "TopLeft";
    ENotificationPosition[ENotificationPosition["TopRight"] = 1] = "TopRight";
    ENotificationPosition[ENotificationPosition["BottomLeft"] = 2] = "BottomLeft";
    ENotificationPosition[ENotificationPosition["BottomRight"] = 3] = "BottomRight";
})(ENotificationPosition || (ENotificationPosition = {}));
export var EActivateGameOverlayToWebPageMode;
(function (EActivateGameOverlayToWebPageMode) {
    EActivateGameOverlayToWebPageMode[EActivateGameOverlayToWebPageMode["Default"] = 0] = "Default";
    EActivateGameOverlayToWebPageMode[EActivateGameOverlayToWebPageMode["Modal"] = 1] = "Modal";
})(EActivateGameOverlayToWebPageMode || (EActivateGameOverlayToWebPageMode = {}));
export var EOverlayToStoreFlag;
(function (EOverlayToStoreFlag) {
    EOverlayToStoreFlag[EOverlayToStoreFlag["None"] = 0] = "None";
    EOverlayToStoreFlag[EOverlayToStoreFlag["AddToCart"] = 1] = "AddToCart";
    EOverlayToStoreFlag[EOverlayToStoreFlag["AddToCartAndShow"] = 2] = "AddToCartAndShow";
})(EOverlayToStoreFlag || (EOverlayToStoreFlag = {}));
